angular.module('unergie.main')
.directive('affectedAccountsDetails', () =>
  ({
      restrict: 'E',
      templateUrl: '/directives/affectedAccountsDetails/affectedAccountsDetails.html',
      scope: {
          account: '=',
      },
      link: ($scope) => {
          $scope.emails = _.map($scope.account.affectedAccounts, 'mail')
      },
  })
)
